import { AppDivider } from '@components/commons';
import { FC } from 'react';
import './Footer.scss';

const Footer: FC = () => (
  <div className='Footer'>
    <AppDivider />
    <label className='FooterName'>
      Copyright © 2025 Nabla Works Corp. All rights reserved.
    </label>
  </div>
);

export default Footer;
